import { z } from 'zod'
import { baseSchema } from './base'

export const serviceSchema = baseSchema
  .extend({
    type: z.literal('service'),
    method: z.enum(['GET', 'POST']).optional(),
    url: z.string().optional(),
    params: z.record(z.string(), z.any()).optional(),
    body: z.any().optional(),
  })
  .describe('数据请求组件，用于调用外部服务，支持 GET 和 POST 请求，返回的数据会存储到 store 中')

export type ServiceSchema = z.infer<typeof serviceSchema>
